import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faComments,
  faPhone
} from '@fortawesome/fontawesome-free-solid';

import misc from '../../misc';
import SessionList from '../../sessions/components/SessionList';

class ClientDetail extends Component {
  renderEmailButton() {
    return (
      <a
        href={`mailto:${this.props.client.email}`}
        className="btn btn-block btn-secondary"
        disabled={!this.props.client.email}
      >
        <FontAwesomeIcon icon={faEnvelope} />
      </a>
    );
  }

  renderSMSButton() {
    return (
      <a
        href={`sms:${this.props.client.phone}`}
        className="btn btn-block btn-secondary"
        disabled={!this.props.client.phone}
      >
        <FontAwesomeIcon icon={faComments} />
      </a>
    );
  }

  renderPhoneButton() {
    return (
      <a
        href={`tel:${this.props.client.phone}`}
        className="btn btn-block btn-secondary"
        disabled={!this.props.client.phone}
      >
        <FontAwesomeIcon icon={faPhone} />
      </a>
    );
  }

  renderClientDetails() {
    const { client } = this.props;
    if (client === null) {
      return null;
    }

    let renderedNotes = '';
    if (client.notes !== null && client.notes.length > 0) {
      renderedNotes = (
        <p className="m-1 mb-4">
          <strong>Notes</strong>
          <br />
          {client.notes.split('\n').map((item, key) => {
            return (
              <span key={key}>
                {item}
                <br />
              </span>
            );
          })}
        </p>
      );
    }

    return (
      <React.Fragment>
        <div className="row no-gutters">
          <div className="col">{this.renderEmailButton()}</div>
          <div className="col pl-1 pr-1">{this.renderPhoneButton()}</div>
          <div className="col">{this.renderSMSButton()}</div>
        </div>
        <h4 className="mt-3 mb-3">
          {client.firstName} {client.lastName}
        </h4>

        <div className="card mb-3">
          <div className="card-header">
            {this.props.sessions.length > 0
              ? 'Upcoming'
              : 'No upcoming sessions'}
          </div>
          <SessionList
            showDates={true}
            sessions={this.props.sessions}
            allClients={this.props.allClients}
            allLocations={this.props.allLocations}
            activeClient={client}
          />
        </div>

        {renderedNotes}
      </React.Fragment>
    );
  }

  renderActionButtons() {
    const { client } = this.props;
    if (client === null) {
      return null;
    }

    return (
      <React.Fragment>
        <Link
          to={`/sessions/new/${client.id}`}
          className="btn btn-primary btn-block"
        >
          Book Session
        </Link>
        <Link
          to={`/clients/edit/${client.id}`}
          className="btn btn-secondary btn-block"
        >
          Client Details
        </Link>
        <Link
          to={`/sessions/past/${client.id}`}
          className="btn btn-secondary btn-block"
        >
          Past Sessions
        </Link>
      </React.Fragment>
    );
  }

  render() {
    const { isLoading, isError, errorMessage } = this.props;
    return (
      <div className="col-md-9 content">
        {isLoading && <misc.components.LoadingAlert />}
        {isError && <misc.components.Alert message={errorMessage} />}
        {this.renderClientDetails()}
        {this.renderActionButtons()}
      </div>
    );
  }
}

ClientDetail.propTypes = {
  client: PropTypes.shape({
    id: PropTypes.string.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string
  }),
  errorMessage: PropTypes.string,
  isError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
};

ClientDetail.defaultProps = {
  client: null
};

export default misc.lib.toJS(ClientDetail);



// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientDetail.js